// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_39LFbLOO9wkTZm1yWutro7","body":"_2uKf5fCNh2WeLffKQz_UsI","group":"_3CKhqDlDhakZ9DbRV6wB_B"};